import { createApi } from '@core/fetch'

/**
 * 创意相关（原素材）
 */
export default {
  warn: createApi('/p/wedding/index.php/admin/APIMerchantMaterials/warn'),
  list: createApi('/p/wedding/index.php/admin/APIMerchantMaterials/list'),
  detail: createApi('/p/wedding/index.php/admin/APIMerchantMaterials/detail')
}
